export const PHONE_DISPLAY = "+91 83350 68213";
export const PHONE_TEL = "tel:+918335068213";
export const WHATSAPP_NUMBER = "918335068213";
export const EMAIL = "salessciencesurgical@gmail.com";

export const waLink = (text) =>
    `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(text)}`;

export const scrollToId = (id) => {
    const el = document.getElementById(id);
    if (!el) return;
    if (window.__lenis) window.__lenis.scrollTo(el, { offset: -80 });
    else el.scrollIntoView({ behavior: "smooth" });
};
